$(() => {
    $('body').on('click', '.b-tab-icons__item', (e) => {
        const $item = $(e.currentTarget);
        const $items = $item.siblings().add($item);
        const index = $item.index();
        
        const $currentTab = $item.closest('.b-simple-tabs__tab').eq(0);
        if ($currentTab.length) {
            const $tabs = $currentTab.find('.b-simple-tabs').eq(0);
            if ($tabs.length) {
                $tabs.trigger('changeTab', index);
            }
        }
        
        $items.removeClass('is-active').eq(index).addClass('is-active');
    })
})